module.exports = __webpack_public_path__ + "static/fonts/UniversLTStd-Light.e93576b.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/UniversLTStd-Light.otf
// module id = QiJs
// module chunks = 1